<mat-spinner
  class="spinner"
  [diameter]="diameter()" />
